import { AccentStatCard } from "../../../../components/common/accent-stat-card";
import { useApi } from "../../../../swr/useApi";
import { salesService } from "../../../api_client";
import type { SaleStatsDto } from "../../../../api";

export function OrdersStats() {
  const { data } = useApi<SaleStatsDto>(
    "orders-stats",
    () => salesService.getSalesStats(),
  );

  return (
    <div className="flex gap-4 max-md:grid max-md:grid-cols-2 max-md:gap-3">
      <AccentStatCard label="Total orders" value={(data?.totalOrders ?? 0).toLocaleString()} accent="cyan" className="flex-1" />
      <AccentStatCard label="In transit" value={(data?.inTransitOrders ?? 0).toLocaleString()} accent="amber" className="flex-1" />
      <AccentStatCard label="Delivered" value={(data?.deliveredOrders ?? 0).toLocaleString()} accent="green" className="flex-1" />
      <AccentStatCard label="Pending approval" value={(data?.pendingApprovalOrders ?? 0).toLocaleString()} accent="green" className="flex-1" />
    </div>
  );
}
